import { render } from "./ScrollButtons.vue?vue&type=template&id=780f1388"
import script from "./ScrollButtons.vue?vue&type=script&lang=js"
export * from "./ScrollButtons.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__